var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('div',[_c('CSpinner',{attrs:{"grow":""}})],1):_vm._e(),(_vm.address)?_c('span',[_vm._v(" "+_vm._s(_vm.address.full_address)+", "+_vm._s(_vm.address.city)+", "+_vm._s(_vm.address.postal_code)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }